import React from "react";
import styled from "@emotion/styled";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
} from "@mui/material";

import ParkkiTheme from "themes/ParkkiTheme";

const StyledFormLabel = styled(FormLabel)`
  color: ${({ error }) => (error ? ParkkiTheme.colors.red : "default")};
  margin-top: ${ParkkiTheme.spacings.teeny};
  margin-bottom: ${ParkkiTheme.spacings.teeny};
  margin-right: ${(props: { inline?: string }) =>
    props?.inline === "true" ? ParkkiTheme.spacings.tiny : "default"};
  flex-basis: ${(props: { inline?: string }) =>
    props?.inline === "true" ? "25%" : "default"};
`;

type StyledFormControlProps = {
  margins?: { left?: string; right?: string; top?: string; bottom?: string };
};

const StyledFormControl = styled(FormControl)<StyledFormControlProps>`
  display: flex;
  margin-right: ${(props) => props?.margins?.right};
  margin-top: ${(props) => props?.margins?.top || ParkkiTheme.spacings.tiny};
  margin-left: ${(props) => props?.margins?.left};
  margin-bottom: ${(props) =>
    props?.margins?.bottom || ParkkiTheme.spacings.tiny};
`;

const StyledRadioGroup = styled(MuiRadioGroup)`
  flex-direction: ${(props: { inline?: string }) =>
    props?.inline === "true" ? "row" : "default"};
`;

type Props = {
  disabled?: boolean;
  id?: string;
  inline?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  title: string;
  values: { value: string; label: string }[];
  value: string;
};

function RadioGroup({
  disabled,
  id,
  inline,
  onChange,
  title,
  values,
  value,
}: Props): JSX.Element {
  return (
    <StyledFormControl>
      {title && (
        <StyledFormLabel id={`${id}-title`} inline={inline?.toString()}>
          {title}
        </StyledFormLabel>
      )}
      <StyledRadioGroup
        id={id}
        inline={inline?.toString()}
        value={value}
        onChange={onChange}
      >
        {values.map((radio, index) => (
          <FormControlLabel
            key={`${radio.label}-${index}`}
            value={radio.value}
            control={
              <Radio
                color="primary"
                id={`${id}-${radio.value}`}
                disabled={disabled}
              />
            }
            label={radio.label}
          />
        ))}
      </StyledRadioGroup>
    </StyledFormControl>
  );
}

RadioGroup.defaultProps = {
  disabled: false,
  inline: false,
  onChange: () => {},
  title: null,
};

export default RadioGroup;
